<template>
    <section id="about">
        <Title 
          :title="$t('about.title')"
          :description="$t('about.description')" />
        
        <div class="section-content">
            <div class="container-fluid">
                <div class="col-md-12 text-center" v-motion-pop-visible>
                    <Photo />
                </div>
                <div class="row">
                    <div class="presentation col-md-7 mr-auto card-mobile" v-motion-slide-visible-left>
                        <Presentation />
                    </div>
                    <div class="col-md-4 card-mobile" v-motion-slide-visible-right>
                        <PersonnalCard />
                    </div>
                </div>
            </div>
        </div>
        
    </section>
</template>

<script>
    import Title from './Title.vue'
    import PersonnalCard from './PersonnalCard.vue'
    import Presentation from './Presentation.vue'
    import Photo from './Photo.vue'

    export default {
        name: 'AboutMe',
        components: {
            Title,
            PersonnalCard,
            Presentation,
            Photo
        },
    }
</script>

<style scoped lang="scss">
    @import '@/styles/constants.scss';

    .row {
        padding-left: 5%;
        padding-right: 5%;
    }

    .presentation {
        margin-right: 7%;
    }
    #about {
        background-color: lighten(map-get($colors, dark), 100%);
    }

    @media(min-width: #{map-get($breakpoints, medium)}) {
        .section-content {
            width: 80%;
            margin: 0 auto;
        }
    }

    @media(max-width: #{map-get($breakpoints, medium)}) {
        .card-mobile {
            text-align: center !important;
            margin-top: 20px;
        }
    }
</style>
